// Canonical site URL and domain helpers.
// Canonicals, og:url, and JSON-LD always point to the production site.
// Never build SEO URLs from window.location: preview deployments must not claim to be the canonical site.

export const SITE_URL = 'https://www.dangiinnovationlab.com';
export const SITE_NAME = 'Dangi Innovation Lab';

/**
 * Returns the normalized canonical URL for a path or full URL.
 * Canonicals:
 * - Always use SITE_URL (https://www.dangiinnovationlab.com)
 * - Never have query strings (?q=, ?sector=)
 * - Never have hash fragments (#...)
 * - Strip trailing slashes, except for the root URL ('/')
 * - Match the URLs used in the sitemap
 */
export const canonicalFor = (pathOrUrl = '/') => {
  if (!pathOrUrl) return `${SITE_URL}/`;

  let pathname = '';
  if (typeof pathOrUrl === 'string' && /^https?:\/\//i.test(pathOrUrl)) {
    try {
      pathname = new URL(pathOrUrl).pathname;
    } catch {
      pathname = pathOrUrl.replace(/^https?:\/\/[^/]+/i, '').split(/[?#]/)[0];
    }
  } else {
    pathname = String(pathOrUrl).split(/[?#]/)[0];
  }

  if (!pathname.startsWith('/')) {
    pathname = `/${pathname}`;
  }

  // Collapse multiple slashes into a single slash
  pathname = pathname.replace(/\/+/g, '/');

  // Root URL ends with a slash to match sitemap; all other paths strip trailing slash
  if (pathname === '/' || pathname === '') {
    return `${SITE_URL}/`;
  }

  return `${SITE_URL}${pathname.replace(/\/+$/, '')}`;
};
